import { ApplicationContainer, Content, Device, PlaybackError, User, UserType } from 'fl-analytics';
import { ResourceVm } from 'qp-ui-interface';
import { isLoggedIn } from '../../shared/utils/LoginUtils';
import { LocalStorageKeys } from '../../shared/LocalStorageKeys';
import { FireboltService } from '../../shared/services/firebolt.service';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';

/**
 * Get Device Info
 *
 * @returns
 */
export const getDeviceInfo = async (deviceId: string, fireBoltService: FireboltService): Promise<Device> =>
  ({
    platformType: 'web',
    category: 'comcast',
    type: 'Comcast',
    customDeviceManufacturer: await fireBoltService?.getDeviceManufacturer(),
    customDeviceName: await fireBoltService?.getDeviceName(),
    platformName: await fireBoltService?.getDevicePlatform(),
    qpGlobalId: deviceId,
  } as Device); // TODO: This casting has to be done since currently there is no 'Comcast' platform name in the sdk

/**
 * get User Info
 *
 * @returns
 */
export const getUserInfo = (localStorageService: LocalStorageService): User => {
  const userId = localStorage.getItem(LocalStorageKeys.USER_ID) || '';
  const profileId = localStorage.getItem(LocalStorageKeys.USER_ID) || ''; // The same is being sent since there are no profiles
  return {
    id: userId,
    type: isLoggedIn(localStorageService) ? UserType.REGISTERED : UserType.REGISTERED,
    subscription: undefined,
    profileId,
  };
};

/**
 * Get Content
 *
 * @param resource
 * @returns
 */
export const getContentFromResource = (resource: ResourceVm): Content =>
  ({
    id: resource.id,
    name: resource.title,
    type: resource.contentType,
    genre: resource.contentGenre?.toString(),
    seriesName: resource?.seriesTitle,
    seriesId: resource?.seriesId,
    seasonNumber: resource?.seasonNumber?.toString(),
    providerId: resource?.providerName,
    episodeNumber: resource?.episodeNumber?.toString(),
  } as Content);

/**
 * Get Application Container
 *
 * @param resource
 * @returns
 */
export const getApplicationContainer = (resource: ResourceVm): ApplicationContainer => ({
  id: resource.containerId,
  name: resource.containerName,
});

/**
 * Create datazoom error object
 *
 * @param errorCode
 * @param errorDescription
 * @param error
 * @param content
 * @param source
 * @param container
 * @returns
 */
export const getPlaybackError = (
  errorCode: string,
  errorDescription: string,
  error: unknown,
  content: Content,
  source: string,
  container?: ApplicationContainer
): PlaybackError => {
  return {
    code: errorCode,
    message: errorDescription,
    content,
    container,
    description: errorDescription,
    internalError: error,
    playbackSource: source,
  };
};
